import { render, staticRenderFns } from "./PwaInstallPrompt.vue?vue&type=template&id=02782f4c&scoped=true"
import script from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
export * from "./PwaInstallPrompt.vue?vue&type=script&lang=js"
import style0 from "./PwaInstallPrompt.vue?vue&type=style&index=0&id=02782f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02782f4c",
  null
  
)

export default component.exports